import { useNavigate } from "react-router-dom";

function BoxConsultations(props) {
  const navigate = useNavigate();
  const { stats } = props;

  return (
    <div className="box box-consultations">
      <h3
        className="cursor"
        onClick={() => {
          navigate("consultation");
        }}
      >
        Consultations
      </h3>
      <div className="col-2">
        <div>
          <span className="sub-title-gray">Ce mois-ci</span>

          <span className="primary-text">{stats.monthConsultations}</span>
          <span className="sub-text">Le mois précédent</span>
          <span className="secondary-text">{stats.lastMonthConsultations}</span>
        </div>
        <div>
          <span className="sub-title-gray">Aujourd'hui</span>

          <span className="primary-text">{stats.todayConsultations}</span>
          <span className="sub-text">Hier</span>
          <span className="secondary-text">{stats.yesterdayConsultations}</span>
        </div>
      </div>
    </div>
  );
}

export default BoxConsultations;
